import { LandmarkPair, LandmarkPoint } from './landmark';

export type MarkerHalf = 'fixed' | 'moving' | null;

export type LandmarkPressAction =
    | {
          readonly kind: 'drag';
          readonly half: 'fixed' | 'moving';
          readonly point: LandmarkPoint;
      }
    | { readonly kind: 'select' };

export function landmarkPressAction(
    pair: LandmarkPair | undefined,
    half: MarkerHalf,
    selectedPairId: string | null
): LandmarkPressAction {
    const point = pair && half ? pair[half] : undefined;
    if (!pair || !half || !point || pair.id !== selectedPairId) {
        return { kind: 'select' };
    }
    return { kind: 'drag', half, point };
}
